module.exports = __webpack_public_path__ + "img/sixpackcarrier16.b830562a.jpg";